import { useState, type JSX } from 'react';
import './style.scss';

function ExpandableListItem({
  id,
  className,
  collapsedContent,
  renderExpandedContent,
  onExpandChange,
}: {
  id: string;
  className?: string;
  collapsedContent: JSX.Element;
  renderExpandedContent: (isVisible: boolean) => JSX.Element;
  onExpandChange?: (toBeExpanded: boolean) => void;
}) {
  // === STATE ===
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <li className={`expandable-list-item ${isExpanded ? 'expandable-list-item--expanded border border-gray-1000 bg-white position-relative pb-3 rounded' : ''} ${className ?? ''}`}>
      <div className="expandable-list-item__header">
        <div
          className={`expandable-list-item__collapse py-3 ps-3 ${!isExpanded ? 'collapsed' : ''}`}
          tabIndex={0}
          role="button"
          aria-expanded={isExpanded}
          aria-controls={`${id}-expandable-content`}
          onKeyUp={(e) => {
            if (e.key === 'Enter') setIsExpanded(!isExpanded);
          }}
          onClick={() => {
            onExpandChange?.(!isExpanded);
            setIsExpanded(!isExpanded);
          }}
        >
          {collapsedContent}
        </div>
      </div>
      <div id={`${id}-expandable-content`} className={`expandable-list-item__details bg-white px-3 ${isExpanded ? 'expandable-list-item__details--expanded position-relative' : ''}`}>
        {renderExpandedContent(isExpanded)}
      </div>
    </li>
  );
}

export default ExpandableListItem;
